import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltActivityLogHeaderTitleWireframe from './VeltActivityLogHeaderTitleWireframe/VeltActivityLogHeaderTitleWireframe';
import VeltActivityLogHeaderFilterWireframe from './VeltActivityLogHeaderFilterWireframe/VeltActivityLogHeaderFilterWireframe';
import VeltActivityLogHeaderCloseButtonWireframe from './VeltActivityLogHeaderCloseButtonWireframe/VeltActivityLogHeaderCloseButtonWireframe';
var VeltActivityLogHeaderWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogHeaderWireframe.Title = VeltActivityLogHeaderTitleWireframe;
VeltActivityLogHeaderWireframe.Filter = VeltActivityLogHeaderFilterWireframe;
VeltActivityLogHeaderWireframe.CloseButton = VeltActivityLogHeaderCloseButtonWireframe;
export default VeltActivityLogHeaderWireframe;
